export enum FileType {
  csv = 'csv',
  txt = 'txt',
  xls = 'xls',
  xlsx = 'xlsx'
}
